import ApexChart from 'vue3-apexcharts';
import {defineNuxtPlugin} from '#imports';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ApexChart);
});
